import React from 'react';

import styled from 'styled-components';
import { FlexContainer } from 'styles/common';

import { Typography3 } from 'uiToolkit/Typography';

export default function NewSectionHeader({ heading, icon = null, ...props }) {
  return (
    <NewHeaderContainer {...props}>
      <FlexContainer>
        {icon}
        <Typography3 leftGutter={1.5}> {heading} </Typography3>
      </FlexContainer>
      {props.rightContent}
    </NewHeaderContainer>
  );
}

const NewHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 1.5rem;
`;
